// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-_SYSb","closeIcon":"closeIcon-B8JOR","designSwitcherBtn":"designSwitcherBtn-jUDLB"};